import React from 'react'
import { Close } from '@mui/icons-material'
import { M_InputTextField, M_SimpleTable } from 'src/M_Components'
import './utils.css'

export default function TableCustomsOffice({ dictCustomOfficeDict, setDictCustomOFficeDict, isApprove, customsRows, setCustomsRows }) {

    const columns = [
        { label: 'Number', type: 'int' },
        { label: 'Document Type', type: 'textfield' },
        { label: 'Despatch number', type: 'textfield' },
        { label: 'Customs office', type: 'textfield' },
        { label: 'Date', type: 'date' },
    ]

    // 🔹 Estilos de destaque
    const stylesNewCustoms = {
        borderTop: '2px solid var(--color-green)',
        borderBottom: '2px solid var(--color-green)',
    }

    // 🔹 Novo estilo para DBStatus === 'D'
    const stylesDeletedCustoms = {
        borderTop: '2px solid var(--color-red)',
        borderBottom: '2px solid var(--color-red)',
        backgroundColor: 'var(--color-grey)', // leve tom de vermelho no fundo
    }

    // 🔹 Combina ambos os estilos dinamicamente
    const getRowStyle = (rowData) => {
        let style = {}
        if (rowData?.shipmentChanged?.includes('CustomsOfficeId')) {
            style = { ...style, ...stylesNewCustoms }
        }
        if (rowData?.DBStatus === 'D') {
            style = { ...style, ...stylesDeletedCustoms }
        }
        return style
    }

    const deleteButton = (rowData) => {
        return (
            <div
                style={{
                    padding: '2px',
                    ...getRowStyle(rowData),
                    borderRight: '2px solid var(--color-green)',
                    borderTopRightRadius: '5px',
                    borderBottomRightRadius: '5px',
                    height: '36px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {rowData.DBStatus !== 'D' ?
                    <Close
                        className='cursorPointer'
                        style={{ color: 'var(--color-red)' }}
                        onClick={() => deleteRow(rowData)}
                    />
                    : null}
            </div>
        )
    }

    const editField = (rowData, code, data) => {
        let tempObj = { ...rowData, [code]: data }
        setDictCustomOFficeDict(dictCustomOfficeDict.map(obj =>
            obj.id === rowData.id ? tempObj : obj
        ))
    }

    const textInputDefault = (rowData, code) => (
        <div style={getRowStyle(rowData)}>
            <M_InputTextField
                padding='0px'
                paddingLeft='3px'
                height='26px'
                margin='3px'
                draggable={false}
                className='inputColumnsCustoms'
                type='text'
                value={rowData[code]}
                onChange={(e) => editField(rowData, code, e.target.value.toUpperCase())}
                color={
                    rowData?.shipmentChanged.includes(code) &&
                        !rowData?.shipmentChanged?.includes('CustomsOfficeId')
                        ? 'var(--color-yellow)'
                        : 'var(--color-white)'
                }
                disabled={rowData.DBStatus === 'D' ? true : false}
            />
        </div>
    )

    const textInputMaxLength = (rowData, code) => (
        <div style={getRowStyle(rowData)}>
            <M_InputTextField
                padding='0px'
                paddingLeft='3px'
                height='26px'
                margin='3px'
                draggable={false}
                className='inputColumnsCustoms'
                type='text'
                maxLength={18}
                value={rowData[code]}
                onChange={(e) => editField(rowData, code, e.target.value.toUpperCase())}
                color={
                    rowData?.shipmentChanged.includes(code) &&
                        !rowData?.shipmentChanged?.includes('CustomsOfficeId')
                        ? 'var(--color-yellow)'
                        : 'var(--color-white)'
                }
            />
        </div>
    )

    const textInputDate = (rowData, code) => (
        <div style={getRowStyle(rowData)}>
            <M_InputTextField
                padding='0px'
                paddingLeft='3px'
                height='26px'
                margin='3px'
                draggable={false}
                className='inputColumnsEquipment inputStyle'
                type='date'
                value={rowData[code]}
                onChange={(e) => editField(rowData, code, e.target.value)}
                color={
                    rowData?.shipmentChanged.includes(code) &&
                        !rowData?.shipmentChanged?.includes('CustomsOfficeId')
                        ? 'var(--color-yellow)'
                        : 'var(--color-white)'
                }
            />
        </div>
    )

    const docTypeStyle = {
        display: 'flex',
        padding: '7px',
        marginTop: '1px',
        marginBottom: '1px',
        justifyContent: 'center',
    }

    const NumberStyle = {
        fontWeight: 'bolder',
        padding: '7px',
        display: 'flex'
    }

    const dynamicColumns = () => {
        const tempObj = columns.map((elem) => {
            if (elem.label === 'Number') {
                return {
                    header: '#',
                    body: (data) => (
                        <span
                            style={{
                                ...NumberStyle,
                                ...getRowStyle(data),
                                borderLeft: data?.shipmentChanged?.includes('CustomsOfficeId')
                                    ? '2px solid var(--color-green)'
                                    : '',
                                borderTopLeftRadius: '5px',
                                borderBottomLeftRadius: '5px',
                            }}
                        >
                            {data.id}
                        </span>
                    )
                }
            } else if (elem.label === 'Document Type') {
                return {
                    field: elem.label,
                    header: elem.label,
                    body: (data) => (
                        <span style={{ ...docTypeStyle, ...getRowStyle(data) }}>
                            {data[elem.label]}
                        </span>
                    )
                }
            } else if (elem.label === 'Date') {
                return {
                    field: elem.label, header: elem.label, body: (data) => data.DBStatus === 'E' ? textInputDate(data, elem.label) : <span style={{ ...docTypeStyle, ...getRowStyle(data) }}>
                        {data[elem.label] || ''}
                    </span>
                }
            } else if (elem.label === 'Customs office') {
                return {
                    field: elem.label, header: elem.label, body: (data) => data.DBStatus === 'E' ? textInputDefault(data, elem.label) : <span style={{ ...docTypeStyle, ...getRowStyle(data) }}>
                        {data[elem.label] || ''}
                    </span>
                }
            } else if (elem.label === 'Despatch number') {
                return {
                    field: elem.label, header: elem.label, body: (data) => data.DBStatus === 'E' ? textInputMaxLength(data, elem.label) : <span style={{ ...docTypeStyle, ...getRowStyle(data) }}>
                        {data[elem.label] || ''}
                    </span>
                }
            }
        })
        tempObj.push({ body: deleteButton })
        return tempObj
    }

    const deleteRow = (value) => {
        const tempArray = dictCustomOfficeDict.filter(elem => elem.id !== value.id)
        setDictCustomOFficeDict(tempArray)
    }

    const onSelectionChange = (e) => {
        setCustomsRows(e.value || [])
    }

    return (
        <>
            {dictCustomOfficeDict.length !== 0 &&
                <div className='divTable'>
                    <M_SimpleTable
                        rows={dictCustomOfficeDict}
                        columns={dynamicColumns()}
                        selectedRows={customsRows}
                        onSelectionChange={isApprove ? onSelectionChange : null}
                        isSelectMultiple={isApprove}
                        className='BLTable'
                    />
                </div>
            }
        </>
    )
}
